export const buildApiUrl = (apiEndpoint, absolute) => {
    const baseUrl = process.env.REACT_APP_API_URL_BASE.endsWith('/')
        ? process.env.REACT_APP_API_URL_BASE
        : process.env.REACT_APP_API_URL_BASE + '/'

    return absolute ? apiEndpoint : baseUrl + apiEndpoint
}